import moderateFacebookComment from './moderate_facebook_comment';
import { ModerationAction } from 'models/conversation_message';

export default class DeleteFacebookComment {
  constructor(context) {
    this.context = context;
  }

  run({ commentId }) {
    moderateFacebookComment(this.context, { commentId, action: ModerationAction.delete });
  }
}
